module.exports = __webpack_public_path__ + "img/exam.67a6d378.jpg";